import { SystemDescriptions } from "src/common/descriptions";
import { formatToCurrency, formatToDisplayDatetime } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.CONTRACT_PAYMENT.CASHBOX_STATEMENTS

export enum ColumnsKeys {
    NO = 'key',
    DATETIME = 'datetime',
    DESCRIPTION = 'description',
    PREVIOUS = 'previous',
    CREDIT = 'credit',
    DEBIT = 'debit',
    BALANCE = 'balance',
    ACTIONS = 'ACTIONS',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.DATETIME,
        dataIndex: ColumnsKeys.DATETIME,
        key: ColumnsKeys.DATETIME,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToDisplayDatetime(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.PREVIOUS,
        dataIndex: ColumnsKeys.PREVIOUS,
        key: ColumnsKeys.PREVIOUS,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.CREDIT,
        dataIndex: ColumnsKeys.CREDIT,
        key: ColumnsKeys.CREDIT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.DEBIT,
        dataIndex: ColumnsKeys.DEBIT,
        key: ColumnsKeys.DEBIT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.BALANCE,
        dataIndex: ColumnsKeys.BALANCE,
        key: ColumnsKeys.BALANCE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.CREDIT]: SummaryType.SUM,
    [ColumnsKeys.DEBIT]: SummaryType.SUM,
    [ColumnsKeys.NO]: SummaryType.COUNT,
}